module.exports = __webpack_public_path__ + "img/sword-large.baa57434.jpg";